export const publicRoutes = {
    root: '/',
    authorize: '/authorize',
    revoke: '/revoke',
    unauthorized: '/401',
    forbidden: '/403',
    notFound: '/404',
    unknownError: '/500',
    notAuthorized: '/notAuthorized',
};

export const privateRoutes = {
    lanes: '/lanes',
    areas: '/areas/:name',
    areaBalance: '/area-balance/:name',
    shippers: '/shippers',
    shipperDetails: '/shippers/:id',
    healthAssessment: '/health-assessment',
    areaHealth: '/area-health',
    shipperHealth: '/shipper-health',
    shipperHealthDetails: '/shipper-health/:id',
    networkRx: '/network-rx',
};
